import { ThunkType } from "../../../../core/store/reducers";
import { getMonthlyProductReport } from "../api/getMonthlyProductReport";
import fileDownload from "js-file-download";
import { setFetchState } from "../monthlyTradeDataSlice";
import moment from "moment";

export const downloadReport = (): ThunkType => async (dispatch, getStore) => {
  const store = getStore();

  if (store.data.auth.current.status !== "successful") {
    return undefined;
  }

  const { filter } = store.ux.reports.monthlyTrade;
  const user = store.data.auth.current.user;
  dispatch(setFetchState({ type: "started" }));
  const monthlyReport = await dispatch(getMonthlyProductReport(user, filter));
  if (monthlyReport) {
    fileDownload(
      new Blob([monthlyReport as any], { type: "application/pdf" }),
      "MonthlyPTrading_" + moment().format("YYYYMMDDhhmmss") + ".pdf"
    );
  }
  dispatch(setFetchState({ type: "not-started" }));
};
